import React from "react";
import { getWeatherWidget, getDigitalClockWidget, getCalendarWidget, getAnalogClockWidget, updateAnalogClock } from "./widget";

const playlistMediaType = {
  TYPE_MP4: 'mp4',
  TYPE_PDF: 'pdf',
  TYPE_PPT: 'pptx',
  TYPE_IMAGE_JPG: 'jpg',
  TYPE_IMAGE_JPEG: 'jpeg',
  TYPE_IMAGE_PNG: 'png',
  TYPE_IMAGE_GIF: 'gif',
  TYPE_CLOCK: 'clock',
  TYPE_WEATHER: 'weather',
  TYPE_CALENDAR: 'calendar',
  TYPE_ANALOG: 'Analog',
  TYPE_DIGITAL: 'Digital',
  TYPE_LINK: 'link',
  TYPE_LINK_EMBED_CODE: 'code',
  TYPE_LINK_YOUTUBE: 'youtube',
  TYPE_LINK_VIMEO: 'vimeo',
  TYPE_WIDGET_WEATHER: 'weather',
  TYPE_WIDGET_CLOCK: 'clock',
  TYPE_WIDGET_CALENDAR: 'calendar',
};

let playlistCurIndex = 0;

let environment = "cloud";
if (document.currentScript.src.includes("staging")) {
  environment = "staging";
};
if (document.currentScript.src.includes("staging2")) {
  environment = "staging2";
};
if (document.currentScript.src.includes("prod")) {
  environment = "prod";
};
if (document.currentScript.src.includes("dev") || document.currentScript.src.includes("local") || document.currentScript.src.includes("192.168.7.209")) {
  environment = "dev";
};

const backEndAPIAddrForResource = `https://${environment}.screenbeam.com/api/signage/resources`;

 // const testIP = '10.0.0.7';
 // const backEndAPIAddrForResource = `https://${testIP}:3001/api/signage/resources`;
let urlPath = `${backEndAPIAddrForResource}/`;
let playlistContainer = null;
let displayingPlaylist = [];
let playlistCurIsLoop = false;
let widgetTimers = {};
let abortController = null;
export async function UpdatePlaylistContent(playlistData, container, isLoop) {
  if (abortController) {
    abortController.abort();
  }
  abortController = new AbortController();
  playlistContainer = container;
  displayingPlaylist = playlistData;
  playlistCurIndex = 0;
  playlistCurIsLoop = isLoop;
  Object.values(widgetTimers).forEach(clearInterval);
  widgetTimers = {};

  await UpdatePlaylistPlaybackContent(abortController.signal);
}
function getItemUrl(item) {
  if (item.urls && item.urls.length > 0) {
    return item.urls[0];
  }
  if (item.content && item.content.urls && item.content.urls.length > 0) {
    return item.content.urls[0];
  }
  return "";
}
function getItemEmbedCode(item) {
  if (item.embedCode && item.embedCode.length > 0) {
    return item.embedCode;
  }
  if (item.content && item.content.embedCode && item.content.embedCode.length > 0) {
    return item.content.embedCode;
  }
  return "";
}

window.onbeforeunload = () => {
  Object.values(widgetTimers).forEach(clearInterval);
  widgetTimers = {};
  if (abortController) {
    abortController.abort();
    abortController = null;
  }
  if (playlistContainer) {
    playlistContainer.innerHTML = '';
  }
  displayingPlaylist = [];
  playlistCurIndex = 0;
  playlistCurIsLoop = false;
  console.log("Cleared all intervals on page unload");
};

async function UpdatePlaylistPlaybackContent(signal) {
  if (signal.aborted) return;

  if (displayingPlaylist.length === 0) {
    playlistContainer.innerHTML = ``;
    console.log('No playlist to display');
    return;
  }

  if (playlistCurIndex >= displayingPlaylist.length) {
    console.log('playlistCurIndex is greater than or equal to displayingPlaylist length');
    if (playlistCurIsLoop) {
      console.log('playlistCurIsLoop is true, reset playlistCurIndex to 0');
      playlistCurIndex = 0;
      await UpdatePlaylistPlaybackContent(signal);
    }
    else {
      playlistContainer.innerHTML = ``;
      console.log('playlist playback finished');
      return;
    }
  } else {
    playlistContainer.innerHTML = '';
    let item = displayingPlaylist[playlistCurIndex];
    if (item && item.type) {
      switch (item.type) {
        case playlistMediaType.TYPE_MP4:
          {
            if (getItemUrl(item)) {
              // Create video element
              let videoElement = document.createElement("video");
              videoElement.setAttribute('id', item.id);
              videoElement.controls = false; //dispaly controls bar
              videoElement.autoplay = true; // Auto play the video
              videoElement.muted = true; // Mute the video by default
              /*videoElement.width = '100%';
              videoElement.height = 'auto'; // Adjust as needed*/

              // create source element
              const sourceElement = document.createElement('source');
              if (item.type === playlistMediaType.TYPE_LINK_YOUTUBE) {
                sourceElement.src = 'https://www.youtube.com/embed/SQCmDBr0_ZM?list=PLuztcmzyQfMZwRXo3zJa_QosqlalWrHph';//item.urls[0];
              } else {
                sourceElement.src = urlPath + getItemUrl(item) || '';
                sourceElement.type = 'video/mp4';
              }

              videoElement.appendChild(sourceElement);
              playlistContainer.appendChild(videoElement);
            } else {
              console.log(`No valid URLs found for item: ${item.id}`);
            }
          }
          break;
        case playlistMediaType.TYPE_PDF:
          {
            if (getItemUrl(item)) {
              const urls = item?.urls?.length > 0 ? item.urls : item?.content?.urls;
              if(urls[0].toLowerCase().endsWith('.pdf')){
                //canvas + pdf.js to render PDF
                let imgElement = document.createElement("canvas");
                imgElement.setAttribute('id', /*"pdf-canvas"*/item.id);
                imgElement.alt = item.name || '';
                playlistContainer.appendChild(imgElement);

                //Render the PDF to the canvas
                renderPDFToCanvas(urlPath + getItemUrl(item), imgElement, item.duration);
                console.log(`********************Render PDF to canvas done: ${urlPath + getItemUrl(item)} duration=${item.duration}`);
              }else if(urls[0].toLowerCase().endsWith('.png') || 
                    urls[0].toLowerCase().endsWith('.jpg') || 
                    urls[0].toLowerCase().endsWith('.jpeg')|| 
                    urls[0].toLowerCase().endsWith('.gif')){
                let imgElement = document.createElement("img");
                imgElement.setAttribute('id', item.id);
                imgElement.src = urlPath + urls[0]; // Assuming the first URL is the image source
                imgElement.alt = item.name || '';
                playlistContainer.appendChild(imgElement);
                if(urls.length > 1){
                    renderImages(urls, imgElement, item.duration);
                }
              }
            } else {
              console.log(`No valid URLs found for item: ${item.id}`);
            }
          }
          break;
        case playlistMediaType.TYPE_PPT:
          {

          }
          break;
        case playlistMediaType.TYPE_IMAGE_JPG:
        case playlistMediaType.TYPE_IMAGE_JPEG:
        case playlistMediaType.TYPE_IMAGE_PNG:
        case playlistMediaType.TYPE_IMAGE_GIF:
          {
            if (getItemUrl(item)) {
              let imgElement = document.createElement("img");
              imgElement.setAttribute('id', item.id);
              imgElement.src = urlPath + getItemUrl(item);
              imgElement.alt = item.name || '';
              playlistContainer.innerHTML = ''; 
              playlistContainer.appendChild(imgElement);
              const urls = item?.urls?.length > 0 ? item.urls : item?.content?.urls;

              if (urls && urls.length > 0) {
                renderImages(urls, imgElement, item.duration);
              } 
            } else {
              console.log(`No valid URLs found for item: ${item.id}`);
            }
          }
          break;
        case playlistMediaType.TYPE_LINK:
        case playlistMediaType.TYPE_LINK_YOUTUBE:
        case playlistMediaType.TYPE_LINK_VIMEO:
          {
            if (getItemUrl(item)) {
              let linkElement = document.createElement("embed");
              linkElement.setAttribute('id', item.id);
              if (item.type === playlistMediaType.TYPE_LINK_YOUTUBE) {
                linkElement.src = getItemUrl(item) || '';
              } else {
                linkElement.src = getItemUrl(item) || '';
              }
              playlistContainer.innerHTML = ''; 
              playlistContainer.appendChild(linkElement);
            } else {
              console.log(`No valid URLs found for item: ${item.id}`);
            }
          }
          break;
        case playlistMediaType.TYPE_LINK_EMBED_CODE:
          {
            console.log(` ************TYPE_LINK_EMBED_CODE **********Creating embed code for item: ${item.id}`);
            if (getItemEmbedCode) {
              let embedElement = document.createElement("div");
              embedElement.setAttribute('id', item.id);
              embedElement.classList.add('embed-container');
              embedElement.innerHTML = getItemEmbedCode(item) || '';
              if (!embedElement.querySelector('iframe')) {
                if (embedElement.querySelector('script')) {
                  const iframe = document.createElement('iframe');
                  iframe.sandbox = 'allow-scripts allow-same-origin';
                  iframe.style.width = '100%';
                  iframe.style.height = '100%';
                  iframe.style.border = 'none';
                  iframe.srcdoc = embedElement.innerHTML;
                  embedElement.innerHTML = ''; // Clear the embedElement content
                  embedElement.appendChild(iframe);
                }
              }
              playlistContainer.innerHTML = '';
              playlistContainer.appendChild(embedElement);
            } else {
              console.log(`No embed code found for item: ${item.id}`);
            }
          }
          break;
        case playlistMediaType.TYPE_CLOCK:
          if ((item?.content?.paramters?.type === playlistMediaType.TYPE_ANALOG) || (item.paramters && item.paramters.type === playlistMediaType.TYPE_ANALOG)) {
            playlistContainer.style.background = "linear-gradient(0deg, #171719, #171719),linear-gradient(180deg, rgba(255, 255, 255, 0.2) 0%, rgba(24, 24, 26, 0.2) 100%, rgba(24, 24, 26, 0.2) 100%)";
            playlistContainer.style.alignContent = "center"; 
            await getAnalogClockWidget("playlistMedia", playlistContainer, item.paramters || item.content?.paramters);
            widgetTimers["playlistMedia"] = setInterval(() => {
              updateAnalogClock("playlistMedia", item.paramters || item.content?.paramters);
            }, 1000);
          } else if ((item?.content?.paramters?.type === playlistMediaType.TYPE_DIGITAL) || (item.paramters && item.paramters.type === playlistMediaType.TYPE_DIGITAL)) {
            playlistContainer.style.background = undefined;
            playlistContainer.style.alignContent = undefined;
            await getDigitalClockWidget("playlistMedia", playlistContainer, item.paramters || item.content?.paramters);
          }
          break;
        case playlistMediaType.TYPE_WEATHER:
          playlistContainer.innerHTML = await getWeatherWidget(item.paramters || item.content?.paramters);
          break;
        case playlistMediaType.TYPE_CALENDAR:
          await getCalendarWidget(item.type + playlistCurIndex, playlistContainer, item.paramters || item.content?.paramters);
          break;
        default:
          break;
      }
    }
    playlistCurIndex++;
    setTimeout(async () => {
      if (signal.aborted) return; 
      Object.values(widgetTimers).forEach(clearInterval);
      widgetTimers = {};
      await UpdatePlaylistPlaybackContent(signal);
    }, item.duration * 1000 || 5000); // Default duration is 5 seconds
  }
}


function renderPDFToCanvas(pdfUrl, canvasElement, duration) {
  let intervalTime = 5000; // Delay in milliseconds between pages
  let pageNum = 1;
  const canvas = canvasElement || document.getElementById('pdf-canvas');
  const ctx = canvas.getContext('2d');
  window.pdfjsLib.getDocument({ url: pdfUrl, withCredentials: true }).promise.then(pdf => {
    console.log(`PDF loaded: ${pdfUrl}  pages=${pdf.numPages} duration=${duration}`);
    if (duration && duration > 0) {
      let interval = (duration / pdf.numPages) * 1000;
      if (interval > 0) {
        intervalTime = interval;
      }
      console.log(`PDF loaded: interval=${interval} ms intervalTime=${intervalTime} ms`);
    }
    renderPDFPage(pdf, pageNum, intervalTime, ctx, canvasElement)
  });
}

function renderPDFPage(pdfDoc, num, intervalTime = 5000, ctx = null, canvas = null) {
  pdfDoc.getPage(num).then(page => {
    const viewport = page.getViewport({ scale: 1.5 });
    canvas.width = viewport.width;
    canvas.height = viewport.height;
    console.log(`******pdf****Rendering page ${num} with viewport width=${viewport.width} height=${viewport.height}`);
    page.render({ canvasContext: ctx, viewport: viewport }).promise.then(async () => {
      if (num < pdfDoc.numPages) {
        console.log(`******pdf***setTimeout to render next page ${num + 1} after ${intervalTime} ms`);
        setTimeout(() => {
          let pageNum = (num % pdfDoc.numPages) + 1;
          renderPDFPage(pdfDoc, pageNum, intervalTime, ctx, canvas)
        }, intervalTime);
      } else {
        console.log(`******pdf***rendered finished successfully`);
      }
    });
  });
}

async function renderImages(imageUrls, imgElement, duration) {
    let intervalTime = 10 * 1000; // Delay in milliseconds between pages
    if(duration && duration > 0){
            let interval = (duration / imageUrls.length) * 1000;          
            if(interval > 0){
                intervalTime = interval;
            }
            console.log(`renderImages: interval=${interval} ms intervalTime=${intervalTime} ms`);
    }
    for(const url of imageUrls.slice(1)){
        await new Promise(resolve => {
           widgetTimers["canva"] = setTimeout(() => {
                console.log(`Processed: ${url}`);
                imgElement.src = urlPath + url;
                resolve();
            }, intervalTime); // Default duration is 10 seconds
        });
    }
}
